import { render, staticRenderFns } from "./AddPart.vue?vue&type=template&id=5c15311a&scoped=true"
import script from "./AddPart.vue?vue&type=script&lang=js"
export * from "./AddPart.vue?vue&type=script&lang=js"
import style0 from "./AddPart.vue?vue&type=style&index=0&id=5c15311a&prod&scoped=true&lang=css"
import style1 from "./AddPart.vue?vue&type=style&index=1&id=5c15311a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15311a",
  null
  
)

export default component.exports